import { isEqual, isString } from "lodash";
export const wrapIfVal = (str, before, after) => {
    if (!str)
        return str;
    return `${before ?? ""}${str}${after ?? ""}`;
};
const splitByWS = (str) => str.split(/\s+/);
export const splitTrim = (str, separator = ",") => str.split(separator).map(_ => _.trim());
export const testPattern = (pattern, target, isLax = false) => {
    if (!target)
        return false;
    if (isString(pattern)) {
        if (isLax) {
            return isEqual(splitByWS(pattern.toLowerCase().trim()), splitByWS(target.toLowerCase().trim()));
        }
        return pattern === target;
    }
    return pattern.test(target);
};
export const joinIfVal = (...parts) => {
    if (parts.find(_ => _ == null))
        return "";
    return parts.join("");
};
export const joinLines = (lines) => lines
    .map(_ => _?.trim())
    .filter(Boolean)
    .join("\n");
export const toTemplateStringArray = (str) => Object.assign([str], {
    raw: [],
});
export const joinSlash = (...frags) => {
    let final = "";
    for (const frag of frags) {
        if (final.length && !final.endsWith("/"))
            final += "/";
        if (final.length && frag.startsWith("/"))
            final += frag.slice(1);
        else
            final += frag;
    }
    return final;
};
export const removeNonAlnum = (str) => {
    return str.replace(/[^a-zA-Z0-9]+/g, " ");
};
export const ensureString = (str, fallback) => {
    return str !== "" && str !== null && str !== undefined && str?.length > 0
        ? str
        : fallback;
};
//# sourceMappingURL=string.js.map